import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: hsla(0, 0%, 100%, 0.15);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  .user_avatar {
    position: relative;
    width: 24px;
    height: 24px;
  }
  .avatar_image.twentyfour {
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    border-radius: 7px;
    font-size: 1.2rem;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/chat_panel.css */
  .message {
    display: flex;
    justify-content: flex-start;
    background: hsla(0, 0%, 100%, 0.04);
    padding: 10px;
    height: fit-content;
    border-radius: 10px;
    margin: 0 15px 8px 0px;
  }
  .message.announcement {
    background: hsla(45, 100%, 41%, 0.25);
  }
  .message .message_content {
    display: inline;
    text-align: left;
    line-height: 140%;
    font-size: 0.75rem;
    margin: 0 0 0 10px;
  }
  .message.announcement .message_content {
    display: flex;
    flex-direction: column;
  }
  .message .message_content .user_name {
    font-weight: 600;
    margin: 0 0 0 0;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    text-decoration: none;
  }
  .message.announcement .message_content .user_name {
    border-bottom: 0;
    color: #d19b00;
    padding-bottom: 3px;
    font-weight: 800;
  }
  .message .message_content .message_copy {
    font-weight: 400;
  }
  .message.announcement .message_content .message_copy {
    line-height: 130%;
  }
`

const developerCSS = css``

export const AnnouncementItemCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
